import React, { useState } from "react";
import "./css/Contact.css";

const TOPICS = [
  "General Inquiry",
  "Partnership",
  "Press & Media",
  "App Support",
  "Advertising",
  "Other",
];

const CONTACT_ITEMS = [
  {
    label: "Email",
    value: "info@vyralmediagroup.com",
    href: "mailto:info@vyralmediagroup.com",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
        <polyline points="22,6 12,13 2,6"/>
      </svg>
    ),
  },
];

const EMPTY = { name: "", email: "", topic: "", message: "" };

const Contact = () => {
  const [form, setForm]           = useState(EMPTY);
  const [submitted, setSubmitted] = useState(false);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const subject = `[${form.topic || "Contact"}] ${form.name}`;
    const body    = `Name: ${form.name}\nEmail: ${form.email}\nTopic: ${form.topic}\n\n${form.message}`;
    window.location.href = `mailto:info@vyralmediagroup.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setSubmitted(true);
    setForm(EMPTY);
  };

  return (
    <div className="ct-page">

      {/* Hero */}
      <section className="ct-hero">
        <div className="ct-hero-inner">
          <p className="ct-eyebrow">Get In Touch</p>
          <h1>Let's Talk</h1>
          <p className="ct-sub">
            Whether you have a question, a partnership idea, or just want to say hello, we'd love to hear from you.
          </p>
        </div>
      </section>

      {/* Body */}
      <div className="ct-body">

        {/* Left panel */}
        <aside className="ct-info">
          <p className="ct-info-heading">Contact Info</p>
          <ul className="ct-contact-list">
            {CONTACT_ITEMS.map(({ label, value, href, icon }) => (
              <li key={label} className="ct-contact-item">
                <span className="ct-ci-icon">{icon}</span>
                <div className="ct-ci-text">
                  <span className="ct-ci-label">{label}</span>
                  <a href={href} className="ct-ci-value" target="_blank" rel="noreferrer">{value}</a>
                </div>
              </li>
            ))}
          </ul>

          <div className="ct-response-note">
            <span className="ct-rn-dot" />
            Typically respond within 1-2 business days
          </div>
        </aside>

        {/* Right panel - Form */}
        <div className="ct-form-wrap">
          {submitted ? (
            <div className="ct-success">
              <div className="ct-success-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <h3>Message Sent!</h3>
              <p>
                Your email client should open shortly. If it doesn't, email us directly at{" "}
                <a href="mailto:info@vyralmediagroup.com">info@vyralmediagroup.com</a>
              </p>
              <button className="ct-again" onClick={() => setSubmitted(false)}>
                Send Another Message
              </button>
            </div>
          ) : (
            <form className="ct-form" onSubmit={onSubmit}>

              <div className="ct-form-row">
                <div className="ct-field">
                  <label>Your Name <span>*</span></label>
                  <input name="name" value={form.name} onChange={onChange} placeholder="Jane Doe" required />
                </div>
                <div className="ct-field">
                  <label>Email Address <span>*</span></label>
                  <input type="email" name="email" value={form.email} onChange={onChange} placeholder="jane@example.com" required />
                </div>
              </div>

              <div className="ct-field">
                <label>Topic</label>
                <select name="topic" value={form.topic} onChange={onChange}>
                  <option value="">Select a topic (optional)</option>
                  {TOPICS.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
              </div>

              <div className="ct-field">
                <label>Message <span>*</span></label>
                <textarea name="message" value={form.message} onChange={onChange} placeholder="Tell us what's on your mind..." rows="6" required />
              </div>

              <button type="submit" className="ct-submit">
                Send Message
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
                  <line x1="5" y1="12" x2="19" y2="12"/>
                  <polyline points="12 5 19 12 12 19"/>
                </svg>
              </button>

            </form>
          )}
        </div>

      </div>
    </div>
  );
};

export default Contact;
